<template>
    <sub-page class="m-addOfflinePlan">
        <el-steps class="step-title" :active="active" finish-status="success" simple>
            <div class="click-zone" @click="toStep(0)"></div>
            <div class="click-zone" @click="toStep(1)"></div>
            <el-step :title="$t('train.basicInfo')" icon="nucfont inuc-edit-info"></el-step>
            <el-step :title="$t('train.trainees')" icon="nucfont inuc-members"></el-step>
        </el-steps>

        <!-- 第一步 -->
        <transition enter-active-class="animated fadeIn">
            <section v-show="active == 0" class="course-step-first">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="$i18n.locale==='zh-CN'?'120px':'200px'"
                         class="form-train"
                >

                    <el-form-item :label="$t('train.name')" prop="name">
                        <el-input v-model="ruleForm.name" :placeholder="$t('tip.name')" clearable></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('train.type')" prop="type">
                        <el-select v-model="ruleForm.type" collapse-tags :placeholder="$t('tip.trainingType')">
                            <el-option :label="item.value" :value="item.id" v-for="item in trainTypeMenu"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('train.time')" required>
                        <el-form-item prop="startTime">
                            <el-date-picker
                                v-model="ruleForm.startTime"
                                type="date"
                                class="date-picker"
                                :placeholder="$t('c.startDate')"
                                :picker-options="pickerOptions1"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                            <span>{{$t('c.to')}}</span>
                            <el-date-picker
                                v-model="ruleForm.endTime"
                                type="datetime"
                                class="date-picker input-without-padding"
                                format="yyyy-MM-dd HH:mm:ss"
                                :placeholder="$t('train.endDate')"
                                :picker-options="pickerOptions2"
                                value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
                        <el-select v-model="ruleForm.forLevel" collapse-tags :placeholder="$t('tip.operatorLevel')">
                            <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('c.examType')" prop="form">
                        <el-select v-model="ruleForm.form" collapse-tags :placeholder="$t('tip.examType')">
                            <el-option :label="item.value" :value="item.id" v-for="item in examFormMenu"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 培训地点 -->
                    <el-form-item :label="$t('train.site')" prop="place">
                        <el-input v-model="ruleForm.place" clearable></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('train.signArea')" prop="range">
                        <el-input-number v-model="ruleForm.range" controls-position="right" :step="50"
                                         :min="0" :max="10000"></el-input-number>
                        {{$t('c.miles')}}

                    </el-form-item>

                    <el-form-item label="培训专题" prop="special">
                        <el-select v-model="ruleForm.special" collapse-tags placeholder="请选择培训专题" clearable>
                            <el-option :label="item.value" :value="item.id" v-for="item in trainSpecialMenu" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item :label="$t('train.classHour')" prop="period">
                        <el-input-number v-model="ruleForm.period" controls-position="right" :min="0"
                                         :max="400"></el-input-number>
                    </el-form-item>
                    <el-form-item :label="$t('train.preTime')">
                        <el-form-item prop="prePublishTime">
                            <el-date-picker
                                type="datetime"
                                :placeholder="$t('tip.datetime')"
                                v-model="ruleForm.prePublishTime"
                                format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions3"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item :label="$t('train.content')" prop="content">
                        <el-input type="textarea"
                                  v-model="ruleForm.content"
                                  :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                    </el-form-item>

                    <div class="btn-group">
                        <el-button type="primary" @click="toStep(1)">{{$t('c.next')}}</el-button>
                    </div>
                </el-form>

                <baidu-map class="bm-map"
                           :center="center"
                           :zoom="zoom"
                           :scroll-wheel-zoom="true"
                           @ready="onMapReady"
                           @dblclick="markPoint"
                >
                    <bm-view class="bm-view"></bm-view>

                    <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>

                    <bm-control :offset="mapSearchOffset">
                        <el-input v-model="mapSearch" :placeholder="$t('tip.name')" size="small" clearable></el-input>
                    </bm-control>

                    <bm-local-search
                        :keyword="mapSearch"
                        :forceLocal="true"
                        :pageCapacity="5"
                        :selectFirstResult="false"
                        :auto-viewport="true"
                        @infohtmlset="infohtmlset"
                    >
                    </bm-local-search>

                    <bm-circle
                        :center="circlePath.center"
                        :radius="ruleForm.range"
                        stroke-color="#22B9FF"
                        :stroke-opacity="1"
                        :stroke-weight="3"
                        @lineupdate="updateCirclePath"
                        :editing="true"></bm-circle>
                </baidu-map>

            </section>

        </transition>

        <!-- 第二步 -->
        <transition enter-active-class="animated fadeIn">
            <div v-show="active == 1">
                <el-form :inline="true" :model="formSearch" class="form-member-query" size="mini">
                    <el-form-item :label="$t('c.userInfo')">
                        <el-input v-model="formSearch.search" :placeholder="$t('tip.userSearch')"
                                  @keyup.enter.native="queryMembers" clearable></el-input>
                    </el-form-item>
                    <select-multiple :nameArrays="selectNames"
                                     v-on:getGroupTypeVal="getGroupTypeVal"
                                     v-on:getPositionTypeVal="getPositionTypeVal"
                                     v-on:getForLevelVal="getForLevelVal">
                    </select-multiple>
                    <select-multi-orgs @orgsChange="orgsChange"></select-multi-orgs>
                    <el-form-item>
                        <advanced-filter @advancedChange="advancedChange" ref="advancedFilter"></advanced-filter>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="queryMembers" :disabled="disable">{{$t('c.query')}}
                        </el-button>
                    </el-form-item>
                </el-form>
                <el-tabs type="border-card" @tab-click="changeTab">
                    <el-tab-pane>
                         <span slot="label" class="member-tab">
                            <el-popover
                                placement="top"
                                width="auto"
                                trigger="hover"
                                v-model="checkAllPopover">
                                <p style="margin-bottom:10px;word-break: break-all">{{$t('train.checkAllMembers')}}</p>
                                <div style="text-align: center; margin: 0">
                                    <el-button type="primary" size="mini" @click="checkAllMembers(true)">{{$t('res.checkAll')}}</el-button>
                                    <el-button size="mini" type="warning" @click="checkAllMembers(false)">{{$t('res.cancelCheckAll')}}</el-button>
                                </div>

                                <a class="check-btn" slot="reference">
                                    <i class="nucfont inuc-bars"></i>
                                </a>
                            </el-popover>
                             {{$t('system.allMembers')}}
                        </span>


                        <!-- 全部学员table -->
                        <data-tables ref="traineeTable"
                                     class="traineeTable"
                                     :data="tableData"
                                     :table-props="tableProps"
                                     :current-page.sync="currentPage"
                                     :page-size="20"
                                     :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                     @select="selectChange"
                                     @select-all="selectAllChange"
                        >
                            <el-table-column type="selection" :reserve-selection="true" width="55"
                                             align="center"></el-table-column>
                            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                             :key="title.label"
                                             align="center"
                                             sortable="custom">
                            </el-table-column>
                        </data-tables>
                    </el-tab-pane>

                    <el-tab-pane :label='selectTableNum'>
                        <!-- 已选学员table -->
                        <data-tables :data="multipleSelection"
                                     :table-props="tableProps"
                                     :page-size="20"
                                     :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                        >
                            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                             :key="title.label"
                                             align="center"
                                             sortable="custom">
                            </el-table-column>
                            <el-table-column :label="$t('c.operation')" align="center" min-width="20%">
                                <template slot-scope="scope">
                                    <el-button
                                        :title="$t('c.delete')"
                                        size="mini"
                                        class="el-icon-delete"
                                        type="primary"
                                        round
                                        @click="delMember(scope.$index, scope.row.id)">
                                    </el-button>
                                </template>
                            </el-table-column>
                        </data-tables>
                    </el-tab-pane>
                </el-tabs>

                <div class="btn-group">
                    <el-button-group>
                        <el-button type="primary" @click="toStep(0)">{{$t('c.prev')}}</el-button>
                        <el-button type="success" @click="submitTraining()" :loading="submitLoading">
                            {{$t('c.finish')}}

                        </el-button>
                    </el-button-group>
                </div>
            </div>
        </transition>

    </sub-page>
</template>


<script>
    import api from '@/api';
    import {Debounce} from '@/utils'
    import {mapGetters} from 'vuex'
    import SubPage from '@/components/Subpage'
    import selectMultiple from '@/components/Selectmultiple'
    import selectMultiOrgs from '@/components/SelectMultiOrgs';
    import uiPanel from '@/components/UIPanel';
    import AdvancedFilter from '@/components/AdvancedFilter';

    export default {
        props: ['planId'],
        components: {
            SubPage,
            selectMultiple,
            selectMultiOrgs,
            uiPanel,
            AdvancedFilter
        },
        data() {
            let validatePass = (rule, value, callback) => {
                if (value && new Date(value).getTime() < new Date().getTime()) {
                    return callback(new Error(this.$t('rule.time')));
                }
                callback();
            };
            return {
                isTraineeBoxFirstInit: true,
                active: 0,
                // 第一步的表单
                ruleForm: {
                    name: '',
                    form: '',
                    startTime: '',
                    endTime: '',
                    forLevel: '',
                    type: '',
                    place: '',
                    coordinate: '',
                    range: 200,
                    special: '',
                    period: 0,
                    prePublishTime: '',
                    content: ''
                },

                center: {
                    lng: 0, lat: 0
                },
                zoom: 3,
                mapSearch: '',
                mapSearchOffset: '',
                circlePath: {
                    center: {
                        lng: 0,
                        lat: 0
                    },
                },

                // 第二步选择学员
                tabIndex: 0,
                tableData: [],
                tableProps: {
                    border: false,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "420px",
                },
                titles: [
                    {
                        prop: 'name',
                        label: this.$t('c.username')
                    }, {
                        prop: 'jobNo',
                        label: this.$t('c.idNo')
                    }, {
                        prop: 'accountNo',
                        label: this.$t('c.account')
                    }, {
                        prop: 'orgName',
                        label: this.$t('c.belong')
                    }, {
                        prop: 'postName',
                        label: this.$t('c.position')
                    }, {
                        prop: 'gradeName',
                        label: this.$t('c.grade')
                    }
                ],
                currentPage: 1,
                selectNames: [
                    {key: "groupType", value: [0]},
                    {key: "positionType", value: [0]},
                    {key: "forLevel", value: [0], title: `${this.$t('c.grade')}`}
                ],
                formSearch: {
                    search: '',
                    orgIds: [],
                    groupIds: [],
                    gradeIds: [],
                    postIds: [],
                    advancedAccountNos: []
                },
                multipleSelection: [],
                checkAllPopover: false,
                submitLoading: false,

                // 表单验证
                rules: {
                    name: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {min: 2, max: 50, message: this.$t('rule.lengthBetween', ['2', '50']), trigger: 'blur'}
                    ],
                    form: [
                        {required: true, message: this.$t('tip.examType'), trigger: 'change'}
                    ],
                    forLevel: [
                        {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                    ],
                    startTime: [
                        {required: true, message: this.$t('tip.startTime'), trigger: 'change'}
                    ],
                    type: [
                        {required: true, message: this.$t('tip.trainingType'), trigger: 'change'}
                    ],
                    place: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    range: [
                        {required: true}
                    ],
                    prePublishTime: [
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    content: [
                        {max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'}
                    ],
                },

            };
        },

        created() {
//            this.$store.dispatch('getForLevelMenu');
//            this.$store.dispatch('getTrainTypeMenu');
//            this.$store.dispatch('getExamFormMenu');

            if (this.planId) {
                this.initData();
            } else {
                this.queryMembers()
            }
        },
        computed: {
            ...mapGetters([
                'forLevelMenu',
                'trainTypeMenu',
                'examFormMenu',
                'trainSpecialMenu',
            ]),
            disable(){
                let disable = true;
                if (this.tabIndex == 0) {
                    disable = false;
                }
                return disable;
            },
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.ruleForm.endTime) return false;
                        return time.getTime() > new Date(that.ruleForm.endTime).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.ruleForm.startTime) return false;
                        return time.getTime() < new Date(that.ruleForm.startTime).getTime()
                    },
                }
            },
            pickerOptions3() {
                return {
                    disabledDate(time) {
                        if (new Date(time).toDateString() === new Date().toDateString()) return false;
                        return time.getTime() < new Date().getTime()
                    },
                }
            },
            selectTableNum() {
                return this.$t('system.selectedMember') + `(${this.multipleSelection.length})`;
            }
        },

        methods: {
            // 加载数据
            initData() {
                let q1 = this.queryMembers();

                let q2 = api.getOfflineDetail(this.planId).then(res => {
                    let data = res.package;

                    // 加载第一步数据
                    for (let item in data) {
                        if (this.ruleForm.hasOwnProperty(item)) {
                            this.ruleForm[item] = data[item];
                        }
                    }

                    if (this.map) this.setMap(this.ruleForm);

                    // 加载第二步学员数据
                    if (this.isTraineeBoxFirstInit) {
                        data.trainees.forEach(val => {
                            val.name = val.userName;
                            val.id = val.userID;
                            delete val.userName;
                            delete val.userID;
                            this.multipleSelection.push(val);
                        });
                        this.isTraineeBoxFirstInit = false;
                    }
                })

                Promise.all([q1, q2]).then(() => {
                    this.updateSelectStatus()

                    this.$nextTick(() => {

                        let $tr = $('.traineeTable').find('tbody tr:eq(0) td:eq(0) label');
                        console.log($tr)
                        $tr.click().click()
                    })
                })
            },
            toStep(e){
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.validate((valid) => {
                        if (valid) {
                            this.active = e;
                        }
                    });
                } else {
                    this.active = e;
                }
            },

            /**
             * 第二步相关
             */
            changeTab(tab, event) {
                this.tabIndex = tab.index;
            },
            // 左边table☑后，把值赋给右边已选中人员table
            selectChange(val) {
                this.multipleSelection = val;
            },
            selectAllChange(val) {
                this.multipleSelection = val;
            },
            updateSelectStatus() {
                let CheckboxElTable = this.$refs.traineeTable.$refs.elTable;

                this.$nextTick(() => {
                    //CheckboxElTable.clearSelection();

                    this.tableData.forEach(row => {
                        if (this.multipleSelection.find(v => v.userID == row.id || v.id == row.id)) {
                            CheckboxElTable.toggleRowSelection(row, true);
                        }
                    });
                })
            },
            delMember(index, id) {
                let ind = this.multipleSelection.findIndex(v => v.id === id);

                /**
                 * 不要直接用index删！使用id查出位置再删
                 * 这样避免了快速点击会多次删除同一数据的bug
                 */
                if (ind > -1) {
                    this.multipleSelection.splice(ind, 1);
                } else {
                    return
                }

                let CheckboxElTable = this.$refs.traineeTable.$refs.elTable;
                let idx = this.tableData.findIndex(v => v.id === id);
                CheckboxElTable.toggleRowSelection(this.tableData[idx], false);
            },
            queryMembers() {
                this.currentPage = 1;
                let queryData = {
                    types: 3,
                    ...this.formSearch
                };

                ['gradeIds', 'postIds'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });

                return api.queryTrainee(queryData).then((res) => {
                    this.tableData = res.package;
                    this.tableData.forEach(row => {
                        row.jobNo = row.jobNo || '--';
                        row.postName = row.postName || '--';
                        row.gradeName = row.gradeName || '--';
                    })

                    //this.updateSelectStatus()
                });

            },

            // 20190131 xia 全选所有人员
            checkAllMembers(checkAll) {
                this.checkAllPopover = false;
                if (checkAll) {
                    this.multipleSelection = [...this.tableData];
                    this.$nextTick(() => {
                        let CheckboxElTable = this.$refs.traineeTable.$refs.elTable;
                        this.tableData.forEach(item => {
                            CheckboxElTable.toggleRowSelection(item, true);
                        })
                    })
                } else {
                    this.multipleSelection = [];
                    this.$nextTick(() => {
                        let CheckboxElTable = this.$refs.traineeTable.$refs.elTable;
                        CheckboxElTable.clearSelection();
                    })
                }
            },

            submitTraining(){
                let submitData = {
                    ...this.ruleForm,
                    trainees: [],
                };

                if (submitData.endTime && submitData.endTime.length < 12) {
                    submitData.endTime = submitData.endTime + ' 23:59:00'
                }

                this.multipleSelection.forEach(val => {
                    submitData.trainees.push({
                        userID: val.id || val.userID
                    })
                });

                this.submitLoading = true;

                if (this.planId) {

                    api.editOffline(this.planId, submitData).then(res => {
                        this.$notify({
                            title: res.error,
                            message: this.$t('train.editSuccess'),
                            type: 'success',
                            duration: 2000
                        });

                        this.submitLoading = false;
                        this.$emit('onClose');
                        this.$router.replace({name: 'trainPlan'})
                    }).catch(e => this.submitLoading = false);

                } else {

                    api.postOffline(submitData).then(res => {
                        this.$notify({
                            title: res.error,
                            message: this.$t('train.addSuccess'),
                            type: 'success',
                            duration: 2000
                        });

                        this.submitLoading = false;
                        this.$emit('onClose');
                        this.$router.replace({name: 'trainPlan'})
                    }).catch(e => this.submitLoading = false);
                }

            },

            /**
             *  百度地图
             */
            onMapReady({BMap, map}) {
                this.BMap = BMap;
                this.map = map;

                // 0. 初始化
                this.center.lng = 116.404;
                this.center.lat = 39.915;
                this.zoom = 15;
                this.mapSearchOffset = new BMap.Size(100, 6);
                this.map.disableDoubleClickZoom();

                // 1. 配置控件
                map.addControl(new BMap.NavigationControl({
                    type: BMAP_NAVIGATION_CONTROL_SMALL,
                    anchor: BMAP_ANCHOR_TOP_RIGHT
                }));
                map.addControl(new BMap.ScaleControl());

                // 2. 定位当前位置 | 定位已有位置
                if (!this.planId) {
                    let geolocation = new BMap.Geolocation();

                    geolocation.getCurrentPosition(function (r) {
                        // 浏览器定位，具体到坐标（需要https支持）
                        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                            let mk = new BMap.Marker(r.point);
                            map.addOverlay(mk);
                            map.panTo(r.point);
                            console.log('您的位置：' + r.point.lng + ',' + r.point.lat);
                        } else {
                            // IP定位，具体到城市
                            let myCity = new BMap.LocalCity();
                            myCity.get(result => {
                                let cityName = result.name;
                                map.setCenter(cityName);
                                console.log("当前定位城市:" + cityName);
                            });
                        }
                    });
                } else if (this.ruleForm.coordinate) {
                    this.setMap(this.ruleForm)
                }

            },

            // 定位到已有位置
            setMap(data) {
                console.log('已设位置信息',data)
                let lat = data.coordinate && data.coordinate.split(',')[0];
                let lng = data.coordinate && data.coordinate.split(',')[1];
                let point = new this.BMap.Point(lng, lat);

                // 定位到该位置
                this.center.lng = lng;
                this.center.lat = lat;
                this.zoom = 16;

                // 创建标注
                let marker = new this.BMap.Marker(point);
                this.map.addOverlay(marker);
                let label = new this.BMap.Label(data.place,{offset:new this.BMap.Size(20,-10)});
                marker.setLabel(label);

                // 区域圆
                setTimeout(() => {
                    this.circlePath.center.lat = lat;
                    this.circlePath.center.lng = lng;
                }, 200)
            },

            /**
             * 选择位置后的回调
             * @param data 坐标对象
             * @param needClearCustomMarker 是否清除已创建的自定义标注，默认为true
             *
             */
            infohtmlset(data, needClearCustomMarker = true) {
                let point = data.point;

                this.ruleForm.place = data.address;
                this.ruleForm.coordinate = `${point.lat},${point.lng}`;

                this.circlePath.center.lat = point.lat;
                this.circlePath.center.lng = point.lng;

                if (needClearCustomMarker && this.marker) {
                    this.map.removeOverlay(this.marker);
                }
            },

            // 更改圆大小的回调
            updateCirclePath: Debounce(function({target}) {
                this.ruleForm.range = target.xa.toFixed(0);
            }, 300),

            // 手动点击地图上的点
            markPoint(	{type, target, point, pixel, overlay}) {
                // 如果点到标注，不产生新标注
                if (overlay && overlay.Bc) {
                    return;
                }

                let geoc = new this.BMap.Geocoder();
                geoc.getLocation(point, rs => {
                    if (this.marker) {
                        this.map.removeOverlay(this.marker);
                    }

                    this.marker = new this.BMap.Marker(point);
                    this.map.addOverlay(this.marker);

                    this.infohtmlset(rs, false);
                });
            },

            //搜索赋值
            orgsChange(data) {
                this.formSearch.orgIds = data;
            },
            advancedChange(data) {
                this.formSearch.advancedAccountNos = data;
            },
            getGroupTypeVal(data){
                this.formSearch.groupIds = data;
            },
            getPositionTypeVal(data){
                this.formSearch.postIds = data;
            },
            getForLevelVal(data){
                this.formSearch.gradeIds = data;
            },
        },
        watch: {
            active(val) {
                if (val === 1) {
                    //this.updateSelectStatus()
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    @include scrollbar();

    $panel-bg: #f5f7fa;
    .course-step-first {
        display: flex;
        justify-content: space-between;
    }

    .form-train {
        width: 600px;
        //width: 40%;
        margin-left: 40px;
        margin-top: 10px;
        .el-select {
            width: 100%;
        }
    }

    .step-title {
        position: relative;
        padding: 13px 20%;
        margin-bottom: 30px;

        .click-zone {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 50%;
            cursor: pointer;
            z-index: 1;

            &:nth-of-type(2) {
                left: 50%;
            }
        }
    }

    .form-member-query {
        padding: 5px 10px 10px 20px;
    }

    .btn-group {
        margin-top: 15px;
        text-align: center;
    }

    .el-select-dropdown__item {
        width: 470px;
    }

    .bm-map {
        flex: 1;
        margin: 10px 10px 0 40px;

        .bm-view {
            height: 460px;

            border: 1px solid #dcdfe6;
            border-radius: 4px;
        }

        /deep/ img {
            max-width: none;
        }
    }

    @media screen and (max-width: 1920px) {
        .bm-map .bm-view {
            height: 600px;
        }
    }

    @media screen and (max-width: 1440px) {
        .form-train {
            width: 45%;
            margin-left: 0;
            > .el-form-item {
                margin-bottom: 15px;
            }
            .input-without-padding {
                margin-top: 15px;
            }
        }
        .bm-map {
            margin-left:30px;
        }
    }

    @media screen and (max-width: 1367px) {
        .bm-map .bm-view {
            height: 460px;
        }
    }
</style>

<style lang="scss">
    .m-addOfflinePlan {
        > .el-main {
            overflow-x: hidden;
        }
        .el-step__head.is-process,
        .el-step__title.is-process {
            color: #22b9ff;
        }
        .el-step__head.is-wait,
        .el-step__title.is-wait {
            color: #a3a4a9;
        }
        .el-step__title.is-success,
        .el-step__head.is-success {
            color: #2e7faa;
        }
        .el-step__line {
            display: none;
        }

        .input-without-padding .el-input__inner {
            padding-right: 0;
        }
    }
</style>
